import React, { useState, useEffect } from 'react';
import { Box, TextField } from '@mui/material';
import { ConfirmationModal } from '../ConfirmationModal/ConfirmationModal';

interface PdfExportModalProps {
  open: boolean;
  title: string;
  initialFilename: string;
  isLoading: boolean;
  onConfirm: (filename: string) => void;
  onClose: () => void;
}

export const PdfExportModal: React.FC<PdfExportModalProps> = ({
  open,
  title,
  initialFilename,
  isLoading,
  onConfirm,
  onClose,
}) => {
  const [filename, setFilename] = useState(initialFilename);

  useEffect(() => {
    if (open) {
      setFilename(initialFilename);
    }
  }, [open, initialFilename]);

  const handleConfirm = () => {
    if (filename.trim()) {
      onConfirm(filename);
    }
  };

  const handleFilenameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = e.target.value.replace(/[\\/:*?"<>|]/g, '');
    setFilename(sanitized);
  };

  return (
    <ConfirmationModal
      open={open}
      title={title}
      body={
        <Box sx={{ mt: 2, mb: -2, width: '100%' }}>
          <TextField
            fullWidth
            name="pdf-filename"
            label="PDF Filename"
            value={filename}
            onChange={handleFilenameChange}
            placeholder="Enter filename"
            variant="standard"
            className="redesign"
            InputProps={{
              endAdornment: '.pdf',
            }}
            autoFocus
            data-qa="pdf-filename-input"
          />
        </Box>
      }
      confirmLabel="Export"
      cancelLabel="Cancel"
      onConfirmClicked={handleConfirm}
      onCancelClicked={onClose}
      isLoading={isLoading}
      confirmDisabled={!filename.trim()}
      dataQa="export-pdf-dialog"
    />
  );
};
